<template>
    <div class="panel panel-default" ref="collapsible-item" >
        <div class="panel-heading np-collapsible-item-heading" role="tab" :id="`${parentId}-heading-${id}`" @click="toggle">
            <h4 class="panel-title">
                <a role="button" data-bs-toggle="collapse" :data-bs-parent="`#${parentId}`" ref="heading"  :href="`#${id}`" aria-expanded="true" aria-controls="collapseOne">
                    <slot name="header"></slot>
                    <span class="float-end caretSign">
                        <i v-if="opened" class="fa fa-arrow-up"></i>
                        <i v-else class="fa fa-arrow-down"></i>
                    </span>
                </a>
            </h4>
        </div>
        <div :id="id" ref="collapse-body" class="panel-collapse collapse np-collapsible-item-body" role="tabpanel" aria-labelledby="headingOne">
            <div class="panel-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'np-collapsible-item',
        props: {
            id: String,
            parentId: {
                type: String,
                default: 'accordion'
            },
            open: Boolean
        },
        data: function() {
            return {
                opened: Boolean
            }
        },
        computed: {
            root: function() {
                return this.$refs['collapsible-item'];
            },
        },
        mounted: function() {
            const vm = this;
            $(this.root)
                .on('show.bs.collapse', function() {
                    vm.handleShow();
                })
                .on('hide.bs.collapse', function() {
                    vm.handleHide();
                })
            if (this.open) {
                $(this.$refs['collapse-body']).collapse('show');
            }
        },
        methods: {
            handleShow() {
                this.opened = true;
            },
            handleHide() {
                this.opened = false;
            },
            toggle() {
                $(this.$refs.heading).click();
            }
        },
        watch: {
        }
    }
</script>
<style scoped>
    .panel-heading {
        cursor: pointer;
    }
</style>
